export const first = <T>(array: T[]): T | undefined =>
  (array?.length && array[0]) || undefined
